<template>
    <v-container grid-list-sm text-xs-left>
        <v-form ref="form">
            <v-text-field
                    v-model="user.password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[rules.required, rules.min8]"
                    label="Password"
                    required
                    @click:append="showPassword = !showPassword"
                    @input="$v.password.$touch()"
                    @blur="$v.password.$touch()"
            />
            <v-text-field
                    v-model="user.confirmPassword"
                    :append-icon="showPasswordConfirmed ? 'visibility_off' : 'visibility'"
                    :type="showPasswordConfirmed ? 'text' : 'password'"
                    :rules="[rules.required, rules.min8, passwordConfirmationRule]"
                    label="Confirm Password"
                    required
                    @click:append="showPasswordConfirmed = !showPasswordConfirmed"
                    @input="$v.confirmPassword.$touch()"
                    @blur="$v.confirmPassword.$touch()"
            />

            <v-flex class="mt-3">
                <v-btn round dark color="green" @click="submit">
                    Submit
                </v-btn>
                <v-btn round dark color="red" @click="clear">
                    Clear
                </v-btn>
            </v-flex>
        </v-form>

        <v-dialog v-model="registrationStatus" max-width="450">
            <v-card v-if="registrationError===409">
                <v-card-title class="headline error white--text">Creation failed</v-card-title>
                <v-card-text>User with this username already exists!</v-card-text>
            </v-card>
            <v-card v-else-if="registrationError===200">
                <v-card-title class="headline success white--text">New user successfully created</v-card-title>
                <v-card-text>The new user will receive an email with the credentials.</v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title class="headline error white--text">Creation failed</v-card-title>
                <v-card-text>Something went wrong... Retry!</v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import {validationMixin,} from "vuelidate";
    import {email, maxLength, minLength, required,sameAs} from "vuelidate/lib/validators";
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";

    export default {
        name: "ChangePassword",
        components: {},
        mixins: [validationMixin,],
        validations: {
            password: {required, minLength: minLength(8)},
            confirmPassword: {required, minLength: minLength(8),sameAsPassword: sameAs('password')},
        },

        data: () => ({
            rules: {
                required: value => !!value || 'Required',
                min8: v => v.length >= 8 || 'Password must be at least 8 characters long',
            },
            user: {
                id: "",
                password: "",
                confirmPassword: "",
            },
            registrationStatus: false,
            registrationError: 200,
            showPassword: false,
            showPasswordConfirmed: false,
        }),

        computed: {
            passwordConfirmationRule() {
                return () => (this.password === this.confirmPassword) || 'Password must match'
            },
        },
        methods: {
            submit() {
                this.$v.$touch();
                if(this.$refs.form.validate()) {
                    this.updateUser();
                }
            },
            fillFields(item){
                this.user = item;
                this.user.password = "";
                this.user.confirmPassword = "";
            },
            updateUser(){

                let requestUrl = {
                    url: UrlsService.user + "/" + this.user.id,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    password: this.user.password,
                    confirmPassword: this.user.confirmPassword,

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "patch",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Update password",
                    loading: "Updating",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.$emit("submit")
                        if(response.email !== ""){
                            response.password = this.user.password;
                            //this.sendEmailNewUser(response);
                        }
                        this.clear();
                    });

            },

            sendEmailNewUser(newUser){
                let requestUrl = {
                    url: UrlsService.sendEmail,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        emailInteractionRequest: {
                            from:"nttdata.discovery@gmail.com",
                            to: newUser.email,
                            cc: "nttdata.discovery@nttdata.com",
                            subject:"New NTT DATA Discovery user",
                            content: "Hi " + newUser.firstName + ",\nyour credentials have been updated:\n"+
                                "Username: " + newUser.username + "\nPassword: " + newUser.password + "\n\nLink: https://discovery.nttdataitalia.com//",
                            label: "",
                            sentDate: "",
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData
                    },
                };
                let messages = {
                    title: "Send the email",
                    loading: "Creating",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                    });
            },
            clear() {
                this.showPassword= false;
                this.showPasswordConfirmed = false;
                this.user.username = "";
                this.user.password = "";
                this.user.confirmPassword = "";
                this.user.firstName = "";
                this.user.lastName = "";
                this.user.email = "";
                this.user.role = null;
            },
        },
    };
</script>

<style lang="scss">
</style>

